import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/role/lektor")({
  beforeLoad: requirePermissionGuard("hca.terminy.read"),
});
